import BaseAppController from './common/baseapp_controller';
import HelloWorldApi from '../api/HelloWorldApi';

export default class extends BaseAppController {
    _getApi() {
        return new HelloWorldApi(this._getApiUrls());
    }
}